import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const Conviction = () => {
  return (
    <Box
      paddingTop={{ xs: "35%", sm: "5%" }}
      sx={{
        position: "relative",
        "&::after": {
          position: "absolute",
          content: '""',
          width: "30%",
          zIndex: 1,
          top: 0,
          left: 0,
          height: "30%",
          backgroundSize: "18px 18px",
          backgroundImage: `radial-gradient(${"#00AEEF"} 20%, transparent 30%)`,
          opacity: 0.1,
        },
      }}
    >
      <Box
        width={{ xs: "100%", sm: "40%" }}
        marginLeft={{ xs: "0%", sm: "0%" }}
      >
        <Typography
          variant={"h3"}
          fontWeight={900}
          textAlign={"left"}
          color={"#00AEEF"}
          paddingBottom={"1%"}
        >
          <Typography
            component={"span"}
            variant={"h3"}
            color="#3E4095"
            fontWeight={900}
          >
            Our {""}
          </Typography>
          Conviction
        </Typography>
      </Box>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignCenter={"center"}
        flexWrap={"wrap"}
        width={"100%"}
      >
        <Box
          width={{ xs: "100%", sm: "50%" }}
          padding={{ xs: "5% 0%", sm: "1% 3% 3% 0%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
        >
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            data-aos={"fade-up"}
            lineHeight={"1.625em"}
            padding={"2% 10% 1% 0%"}
          >
            We cannot break the shackles of Poverty and Hunger without building
            capacity amongst the key players of the Food and Agriculture
            Industry. We also believe that the complete engagement of the
            Agriculture value-chain remains the bailout from Africa's Poverty,
            Hunger and Unemployment; the Agriculture Value-Chain is insatiable.
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            data-aos={"fade-up"}
            lineHeight={"1.625em"}
            padding={"2% 10% 1% 0%"}
          >
            We are convinced that when we increase the knowledge of our farmers
            especially the smallholder farmers, women and youths; yields from
            our farm enterprises will increase. This will have a multiple effect
            on tackling Poverty, Hunger and Unemployment.
          </Typography>
        </Box>
        <Box width={{ xs: "100%", sm: "50%" }}>
          <div>
            <iframe
              width="583"
              height="300"
              src="https://www.youtube.com/embed/Q-pMzvDT0Ak"
              title="OUR ENDORSEMENT VIDEO"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            />
          </div>
        </Box>
      </Box>
    </Box>
  );
};

export default Conviction;
